import { render } from "./Start.vue?vue&type=template&id=2bba4003&scoped=true&ts=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=2bba4003&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bba4003"],['__file',"src/components/dashbaord/Start.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bba4003"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bba4003', __exports__)) {
    api.reload('2bba4003', __exports__)
  }
  
  module.hot.accept("./Start.vue?vue&type=template&id=2bba4003&scoped=true&ts=true", () => {
    api.rerender('2bba4003', render)
  })

}


export default __exports__